import type { ProviderKeyInfo } from "../../types/openclaw";
import { CAPABILITIES, getProviderLabel } from "./constants";
import styles from "./shared.module.css";

type Props = {
  provider: string;
  configuredKeys: ProviderKeyInfo[];
  ztcManaged: boolean;
  submitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const RemoveKeyDialog = ({ provider, configuredKeys, ztcManaged, submitting, onConfirm, onCancel }: Props): JSX.Element => {
  const provLabel = getProviderLabel(provider);
  // Last-key warning: any provider in agent's hint list could power chat.
  const agentCap = CAPABILITIES.find((c) => c.id === "agent")!;
  const otherAgentKeys = configuredKeys
    .filter((k) => k.provider !== provider)
    .some((k) => agentCap.hintProviders.includes(k.provider));
  const isLastAgentKey = !otherAgentKeys && !ztcManaged &&
    agentCap.hintProviders.includes(provider);

  return (
    <div className={styles.confirmOverlay} onClick={onCancel}>
      <div className={styles.confirmDialog} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.confirmTitle}>Remove {provLabel} key?</h3>
        {isLastAgentKey ? (
          <p className={styles.confirmWarning}>
            This is the only key powering your AI Assistant. Removing it will
            disable AI for your OpenClaw until you add a new key.
          </p>
        ) : (
          <p className={styles.confirmText}>
            The {provLabel} key will be removed. Any capabilities that depend on
            it will stop working.
          </p>
        )}
        <div className={styles.confirmActions}>
          <button type="button" className={styles.secondaryBtnSm} onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button type="button" className={styles.dangerBtn} disabled={submitting} onClick={onConfirm}>
            {submitting ? "Removing..." : "Remove key"}
          </button>
        </div>
      </div>
    </div>
  );
};
